<template>
  <section class="files-download-grid">
    <div class="container-2">
      <p class="total-found">
        {{ $fn.tr("Found:") }}
        <span> {{ total }} </span>
        <span>{{ $fn.tr("Records") }}</span>
      </p>
      <transition
        name="fade"
        appear
        v-if="_.get(this.contentData, 'data.list.length') === 0"
      >
        <p class="err">
          {{ $fn.tr("შედეგი ვერ მოიძებნა!") }}
        </p>
      </transition>
      <transition name="fade" appear v-else>
        <div class="grid">
          <template v-if="renderComp">
            <FilesCard
              v-for="(item, index) in getData"
              :data="item"
              :key="index"
            />
          </template>
        </div>
      </transition>
      <center>
        <el-pagination
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size.sync="page_size"
          :current-page.sync="current_page"
          :total="total"
          :disabled="false"
          :hide-on-single-page="true"
          @size-change="
            '';


          "
          @current-change="sendData()"
          @next-click="
            '';


          "
          :key="'pagination'"
        >
        </el-pagination>
      </center>
    </div>
  </section>
</template>
<script>
import FilesCard from "../cards/FilesCard.vue";
import fn from "../../helpers/func";

export default {
  props: ["contentData"],

  components: {
    FilesCard
  },
  data() {
    return {
      renderComp: true,
      key: false,
      total: 0,
      filteredData: [],
      current_page:
        _.get(this.$store.state.main.selected_menu, "routeParams.paging") || 1
    };
  },
  created() {
    this.$forceUpdate();
    if (
      _.get(this.contentData, "conf.taxonomies.publication_category.length") > 0
    ) {
      this.$store.commit("main/setStateDeep", {
        key: `filter.taxonomies.publication_category`,
        val: [_.get(this.contentData, "conf.taxonomies.publication_category.0")]
      });
      this.sendData();
    } else {
    }
    if (this.$route.fullPath.includes("paging")) {
      this.current_page = _.get(
        this.$store.state.main.selected_menu,
        "routeParams.paging"
      );
      this.sendData();
    }
  },
  watch: {
    getData: {
      immediate: true,
      handler: function() {
        if (this.getData !== undefined) {
          this.defFun();
        }
      }
    },
    filter: function() {
      this.sendData();
    },
    current_page: function() {
      this.sendData();
      if (
        this.$route.path !=
        this.$store.getters["main/getPagingUrl"](this.current_page)
      ) {
        this.$router.push(
          this.$store.getters["main/getPagingUrl"](this.current_page)
        );
      }
    }
  },
  computed: {
    page_size() {
      let tmp = _.get(this.contentData, "conf.page_count");
      return parseInt(tmp);
    },
    getData() {
      if (this.filteredData.length > 0) {
        return this.filteredData;
      } else {
        return _.get(this.contentData, "data.list");
      }
    },
    filter() {
      return this.$store.state.main.filter;
    }
  },
  methods: {
    defFun() {
      if (this.filteredData.length < 1) {
        this.total = _.get(this.contentData, "data.listCount");
      }
    },
    async sendData() {
      this.renderComp = false;
      let params;
      params = {
        componentUnicId: _.get(this.contentData, "conf.unicId"),
        id: _.get(this.$store.state.main.selected_menu, "id"),
        searchText: this.filter.searchWord,
        pageNumber: this.current_page,
        taxonomies: {
          publication_tags: this.filter.taxonomies.publication_tags,
          publication_category: this.filter.taxonomies.publication_category
        }
      };
      let res = await fn.postData("main/getDataList", params);

      if (res.status == 200) {
        this.filteredData = res.data.list;
        this.total = res.data.listCount;
        this.renderComp = true;
      }
      return true;
    }
  }
};
</script>
<style lang="scss">
.files-download-grid {
  background: var(--thirdy-tranparent);
  padding-bottom: 89px;
  .total-found {
    border-top: 1px solid var(--border);
    padding-top: 25px;
    margin: 0 0 55px;
    color: var(--bonus-txt);
    @media (max-width: 1439px) {
      padding-top: 20px;
    }
    @media (max-width: 1365px) {
      padding-top: 15px;
      margin: 0 0 34px;
    }
    span {
      color: var(--bonus-txt);
      font-weight: bold;
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 30px;
    column-gap: 30px;
    transition: 0.4s ease-in-out;
    &.grid-anim {
      opacity: 0;
      transition: 0.4s ease-in-out;
    }
    @media (max-width: 1599px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (max-width: 1365px) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
}
</style>
